export const type = 'form.tableView';
